import { render, staticRenderFns } from "./RelevantMarker.vue?vue&type=template&id=b3bdd938"
import script from "./RelevantMarker.vue?vue&type=script&lang=js"
export * from "./RelevantMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports